import React from 'react'
import { both, propEq, find, path } from 'ramda'
import { Popover, Position } from '@blueprintjs/core'
import { connect } from 'react-redux'
import { hasLength } from 'shared/helpers/functional'
import 'less/subscription-select.less'

class SubscriptionSelect extends React.Component {

  state = { showing: false }

  changeSubscription = (subId) => {
    const isSelfServiceSubscription = both(
      propEq('subscriptionPlanId', 23),
      propEq('id', Number(subId))
    )
    const selfserviceSub = find(isSelfServiceSubscription, this.props.subscriptions)
    if (selfserviceSub) {
      this.props.changeSubscription(subId)
    } else {
      window.location = `${window.location.origin}/subscriber#s/${subId}`
    }
  }

  togglePopover = () => this.setState({ showing: !this.state.showing })

  popoverWillClose = () => this.setState({ showing: false })
  popoverWillOpen = () => this.setState({ showing: true })

  render () {
    const sortSubscriptions = (s1, s2) => {
      if (this.props.chosenSubscription.id === s1.id) {
        return -1
      } else if (this.props.chosenSubscription.id === s2.id) {
        return 1
      } else if (s1.company.toUpperCase() < s2.company.toUpperCase()) {
        return -1
      }
      return 1
    }
    return (
      <div className="header-section company-name">
        {/* <span className="company">{path(['chosenSubscription', 'company'], this.props)}
          {hasLength(this.props.subscriptions) && this.props.subscriptions.length > 1 && <Popover
            popoverWillClose={this.popoverWillClose}
            popoverWillOpen={this.popoverWillOpen}
            position={Position.BOTTOM}
            popoverClassName="bp3-popover-dismiss"
            content={
              <div className="subscription-select-popover">
                <h3 className="popover-title">Choose account</h3>
                <div className="popover-content">
                  {this.props.subscriptions.sort(sortSubscriptions).map(s =>
                    <a
                      key={s.id}
                      className={`account bp3-popover-dismiss ${s.id === this.props.chosenSubscription.id ? 'active' : ''}`}
                      href="javascript:;"
                      onClick={() => this.changeSubscription(s.id)}
                    >{s.company}
                    </a>
                  )}
                </div>
              </div>
            }
            target={
              <div className={`accounts-toggle popover-${this.state.showing ? 'showing' : 'hiding'}`}>
                <i className="i im-arrow-down" />
              </div>
            }
          />}
        </span> */}
        <div className="breadcrumbs">
          {this.props.breadcrumbs}
        </div>
      </div>
    )
  }
}

const mapState = state => ({
  chosenSubscription: /*state.subscription.chosenSubscription*/{},
  subscriptions: /*state.subscription.subscriptions*/[],
})

const mapDispatch = {
  changeSubscription: payload => ({ type: 'CHANGE_ACTIVE_SUBSCRIPTION_REQUESTED', payload }),
}

export default connect(mapState, mapDispatch)(SubscriptionSelect)
